export function updatePageTitle(pageName) {
    return `Agatha Tender - ${pageName}`;
}
